import Vue from 'vue';
import VeeValidate from 'vee-validate'
import { BootstrapVue } from 'bootstrap-vue'
import * as VueGoogleMaps from "vue2-google-maps";
import VueApexCharts from 'vue-apexcharts'
import Try from './components/try/try.vue';
import Vuelidate from 'vuelidate';
import Vuex from 'vuex'
import FormContracts from './components/modules/contracts/form-contracts/form-contracts.vue'
import TableContracts from './components/modules/contracts/table-contracts/table-contracts.vue';
import TableUnassignedProcesses from './components/modules/workflow/table-unassigned-processes.vue'
import TableAssignedProcesses from './components/modules/workflow/table-assigned-processes.vue'
import ModalScheduleVideoCall from './components/modules/video-call/modal-schedule-video-call.vue'
import InformationPersonal from './components/modules/workflow/information-personal.vue'
import FormFamilyComposition from './components/modules/workflow/form-family-composition.vue'
import FormFamilySick from './components/modules/workflow/form-family-sick.vue'
import FormFamilyInterview from './components/modules/workflow/form-family-interview.vue'
import FormWorkingConditions from './components/modules/workflow/form-working-conditions.vue'
import MedicalHistory from './components/modules/workflow/medical-history.vue'
import HousingInformation from './components/modules/workflow/housing-information.vue'
import RemoteWork from './components/modules/workflow/remote-work.vue'
import SocialAspect from './components/modules/workflow/social-aspect.vue'
import VisitResult from './components/modules/workflow/visit-result.vue'
import PhotographicSupport from './components/modules/workflow/photographic-support.vue'
import loging from '../packs/components/modules/login/login.vue'
import FormClients from './components/modules/clients/form-clients/form-clients.vue'
import MyProcessFinish from './components/modules/workflow/my-finish-proccess.vue'
import ModalAutomationAcademicReferences from './components/modules/workflow/mail-config/modal-automation-academic-references.vue'
import Pagination from 'vue-pagination-2'
Vue.component('pagination', Pagination);
import FormMassive from './components/modules/clients/massive-projects/massive-projects.vue'
import LaboralReferenceConfirmation from './components/modules/workflow/laboral_references_confirm.vue'
import LaboralReferenceConfirmTokenInvalid from './components/modules/workflow/laboral-references-confirm-token-invalid.vue'
import PersonalReferenceConfirmation from './components/modules/workflow/personal-references.vue'
import FamilyReferenceConfirmation from './components/modules/workflow/family_references'
import FilterAssignments from './components/modules/admin/filter-component.vue'
import RegisterReferences from './components/modules/workflow/register-references.vue'
import ScrapperLogsTable from './components/modules/workflow/scrappers_logs.vue'
import ReferenceLogsTable from './components/modules/workflow/references_logs.vue'
import WorkRemoteExpress from './components/modules/workflow/remote-work-express.vue'
import AcademicForm from './components/modules/workflow/academic-form.vue'
import AssignmentsQuality from './components/modules/workflow/assignments-quality.vue'
import ResponseAssignmentQuality from './components/modules/workflow/response-assignment-quality.vue'
import ContactCandidate from './components/modules/workflow/contact-candidate'
import DownloadReport from './components/own/downloadReport'
import RequestDataCandidate from './components/modules/projects/request-data-candidate.vue'
import RequestDataCandidateAutomation from './components/modules/projects/request-data-candidate-automation.vue'
import GlobalEvents from './components/modules/global-events/global-events.vue'
import ClientRules from './components/modules/admin/client-rules.vue'
import Events from './components/events/Events.vue'
import EventDescription from './components/events/EventDescription.vue'
import EventContentVisible from './components/events/EventContentVisible.vue'
import EventDate from './components/events/EventDate.vue'
import EventModal from './components/events/EventModal.vue'
import EventCircle from './components/events/EventCircle.vue'
import EventLine from './components/events/EventLine.vue'
import RulesIncomplete from './components/events/RulesIncomplete.vue'
import TaskValidations from './components/modules/task-validations/TaskValidations.vue'
// components engine metrics
import TryMetrics from './components/metrics/try-metrics.vue';
import IndexLaboralReferences from './components/modules/laboral_references/Index.vue';
//import "bootstrap/dist/css/bootstrap.min.css"
//import "bootstrap-vue/dist/bootstrap-vue.css"
Vue.use(Vuex)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.use(VeeValidate)

Vue.use(BootstrapVue)

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCF5SfRuKX2envJL-5cM4ruaOq1-KI0wbM",
    libraries: "places"
  }
});

import states from './store/states'
import getters from './store/getters'
import mutations from './store/mutations'

const store = new Vuex.Store({
  mutations:mutations,
  state:states,
  getters:getters
})

Vue.use(Vuelidate);
Vue.config.productionTip = false;
Vue.config.devtools = true;
export const eventBus = new Vue();

new Vue({
  store,
  el: '#rails-vue',
    components: {
    'try': Try,
    'table-contracts': TableContracts,
    'form-contracts': FormContracts,
    'table-unassigned-processes': TableUnassignedProcesses,
    'table-assigned-processes': TableAssignedProcesses,
    'modal-schedule-video-call': ModalScheduleVideoCall,
    'information-personal': InformationPersonal,
    'form-family-composition': FormFamilyComposition,
    'form-family-sick': FormFamilySick,
    'form-family-interview': FormFamilyInterview,
    'form-working-conditions': FormWorkingConditions,
    'medical-history': MedicalHistory,
    'housing-information': HousingInformation,
    'remote-work': RemoteWork,
    'social-aspect': SocialAspect,
    'visit-result': VisitResult,
    'photographic-support': PhotographicSupport,
    'login':loging,
    'form-clients':FormClients, //NO eliminar este componente :D
    'my-process-report': MyProcessFinish,
    'form-massive': FormMassive,
    'modal-automation-academic-references': ModalAutomationAcademicReferences,
    'laboral-references-confirm': LaboralReferenceConfirmation,
    'laboral-references-confirm-token-invalid': LaboralReferenceConfirmTokenInvalid,
    'personal-references-confirm':PersonalReferenceConfirmation,
    'family-references-confirm':FamilyReferenceConfirmation,
    'filter-component':FilterAssignments,
    'register-references':RegisterReferences,
    'scrapper-logs':ScrapperLogsTable,
    'reference-logs':ReferenceLogsTable,
    'remote-work-express':WorkRemoteExpress,
    'academic-form': AcademicForm,
    'contact-candidate': ContactCandidate,
    'request-data-candidate': RequestDataCandidate,
    'assignments-quality': AssignmentsQuality,
    'response-assignment-quality': ResponseAssignmentQuality,
    'contact-candidate': ContactCandidate,
    'download-report':DownloadReport,
    'request-data-candidate-automation': RequestDataCandidateAutomation,
    'global-events': GlobalEvents,
    'try-metrics': TryMetrics,
    'client-rules': ClientRules,
    EventDescription,
    EventContentVisible,
    EventDate,
    EventModal,
    EventCircle,
    EventLine,
    RulesIncomplete,
    'task-validations': TaskValidations
  }  
})

new Vue({
  store,
  el: '#rails-vue-two',
    components: {
    'traceability-events': Events,
    EventDescription,
    EventContentVisible,
    EventDate,
    EventModal,
    EventCircle,
    EventLine,
    RulesIncomplete,
    IndexLaboralReferences
  }  
})